import { useTranslation } from 'react-i18next';
import { Spinner } from '@/components/ui';

interface ContentLoaderProps {
  /** Optional label under the spinner; defaults to the generic "loading" text. */
  label?: string;
}

/**
 * Full content-area loading state: a centered spinner that fills the page body.
 * Use to gate a whole route while its prerequisite data (e.g. the patient list)
 * is still loading, so pages don't flash an empty/partial state first.
 */
export function ContentLoader({ label }: ContentLoaderProps) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-ink-mute"
    >
      <Spinner size={32} className="text-primary" />
      <p className="text-sm font-medium">{label ?? t('common.loading')}</p>
    </div>
  );
}
